<template>
    <div
        id="tl-app"
        :class="isV2 ? 'design-v2' : 'design-v1'"
    >
        <PageLoader />
        <router-view />
        <CommonModal />
        <WidgetModalContainer />
        <Toast
            position="bottom-right"
            group="tl"
            append-to="#app"
            :pt="{
                root: { 'data-testid': 'tl-toast', },
                messageContent: { 'data-testid': 'tl-toast-content' },
                closeButton: { 'data-testid': 'tl-toast-close-button' },
            }"
        />
        <GatewayTimeoutToast />
        <div id="widget" />
    </div>
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
import PageLoader from '@/components/panel/PageLoader.vue'
import CommonModal from '@/components/atoms/CommonModal.vue'
import WidgetModalContainer from '@/components/molecules/WidgetModalContainer.vue'
import GatewayTimeoutToast from './modules/errors/components/GatewayTimeoutToast.vue'
import { useToast } from 'primevue/usetoast'
import { usePrimeVue } from 'primevue/config'
import { setToastInstance } from '@/composables/notifications/toast-instance'
import { onMounted, watch } from 'vue'
import { useDesignVersion } from '@/composables/use-design-version'
import { getThemeConfig } from '@/styles/theme/install'
import { tlPrimePresetV1 } from '@/styles/theme/primeThemeConfig.v1'
import { tlPrimePresetV2 } from '@/styles/theme/primeThemeConfig'
import v1FontsCSS from '@/styles/v1-fonts.css?raw'
import v2FontsCSS from '@/styles/v2-fonts.css?raw'

const { isV2 } = useDesignVersion()
const primevue = usePrimeVue()

watch(isV2, (v2) => {
    primevue.config.theme = getThemeConfig(v2 ? tlPrimePresetV2 : tlPrimePresetV1)
}, { immediate: true })

onMounted(() => {
    const toast = useToast()
    setToastInstance(toast)

    const style = document.createElement('style')
    style.textContent = isV2.value ? v2FontsCSS : v1FontsCSS
    document.head.appendChild(style)
})
</script>

<style lang="sass" scoped>
#tl-app
    transition: all .2s
    min-height: 100vh
    background-color: var(--color-white)
    display: block
    position: relative
</style>
